import styled from 'styled-components'

import SearchIcon from '../assets/icons/SVG/SearchIcon'
import { COLORS } from '../commons/Colors'

function NotRegistredComponent(): JSX.Element {
    return (
        <NotRegistredContainer>
            <IconContainer>
                <SearchIcon />
            </IconContainer>
            <NotRegistredTextInformation>
                Você ainda não possui nenhum registro de NOVIDADES no sistema
                <strong> clique no botão nova NOTÍCIA para começar!</strong>
            </NotRegistredTextInformation>
        </NotRegistredContainer>
    )
}

const NotRegistredContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    margin-top: 200px;
`

const IconContainer = styled.div`
    color: ${COLORS.primaryOrange};
    margin-bottom: 30px;
`

const NotRegistredTextInformation = styled.p`
    font-family: Roboto;
    font-size: 12px;
    line-height: 2;
    letter-spacing: 0.09;
    text-align: center;
    color: ${COLORS.primaryOrange};
    text-transform: uppercase;
    width: 60%;
`

export default NotRegistredComponent
